import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  setDoc,
  arrayRemove,
  arrayUnion,
  updateDoc,
} from "firebase/firestore";
import { database } from "../../firebase";
import { serializeFirebaseData } from "../../utils/serializeFirebaseData";

const collectionName = "timeslot";

export const fetchTimeslot = createAsyncThunk(
  "timeslot/fetchTimeslot",
  async (_, { rejectWithValue }) => {
    try {
      const querySnapshot = await getDocs(collection(database, collectionName));
      const timeslot = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...serializeFirebaseData(doc.data()),
      }));
      return timeslot;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateTimeslot = createAsyncThunk(
  "timeslot/updateTimeslot",
  async ({ slotKey, exists }, { rejectWithValue }) => {
    try {
      const timeslotRef = doc(database, collectionName, slotKey);

      if (exists) {
        await deleteDoc(timeslotRef);
        return { slotKey, deleted: true };
      } else {
        await setDoc(timeslotRef, { text: slotKey });
        return { slotKey, deleted: false };
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const disableEnableTimeslot = createAsyncThunk(
  "timeslot/disableEnableTimeslot",
  async ({ id, date }, { rejectWithValue }) => {
    try {
      const timeslotRef = doc(database, collectionName, id);
      const updateData = {};

      if (date) {
        updateData.dates = arrayUnion(date);
      }

      const timeslotSnapshot = await getDocs(
        collection(database, collectionName)
      );
      const timeslotData = timeslotSnapshot.docs
        .find((doc) => doc.id === id)
        ?.data();

      if (timeslotData?.dates?.includes(date)) {
        updateData.dates = arrayRemove(date);
      }

      await updateDoc(timeslotRef, updateData);

      return {
        id,
        date,
        isDisabled: timeslotData?.dates?.includes(date) ? false : true,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
